import MemberArticlePanel from "./MemberArticlePanel";

const CATEGORIES = [
  "Innovation", "Success", "Money", "Culture", "Trends",
  "Lifestyle", "Style", "Coaching and Mentoring", "Business", "International",
];

/** Spotlight — the story of the BUSINESS. This article is what becomes the Cover Star. */
export default function SpotlightSection({ member, article, onArticleChange, coverStar }) {
  return (
    <MemberArticlePanel
      member={member} article={article} onArticleChange={onArticleChange}
      kind="spotlight" sectionId="section-spotlight" tid="spotlight"
      heading="Spotlight" note="the story of the business — this piece becomes the Cover Star"
      categories={CATEGORIES}
      publicNote="Publish Now sends this live to /the-edit under the Spotlight tag."
      extraFooter={coverStar}
    />
  );
}
